import React, { useEffect } from "react";
import { useRef } from "react";
import "../../Style/Experience.css";
// import Weblogo from "../../Assets/Webimp.jpeg"
import { MdOutlineArrowRightAlt } from "react-icons/md";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

function Experience() {
  const box = useRef();
  useGSAP(() => {
    gsap.to(".spinner-Experince", {
      rotate: 360,
      duration: 5,
      repeat: -1,
      ease: "linear",
    });
  });
  const sectionRef = useRef(null);
  const sectionRef2 = useRef(null);




//   useEffect(() => {
//   gsap.fromTo(
//     ".Exp-div-h1",
//     {
//       x: 0,
//       rotateX: 0,
//       opacity: 1,
//     },
//     {
//       z: -500,
//       rotateX: 15,
//       // opacity: 0.3,
//       transformOrigin: "center center", // Optional: for better tilt effect
//       ease: "power2.out",
//       scrollTrigger: {
//         trigger: ".Exp-div-h1",
//         start: "center center", // ✅ Starts when it's halfway visible
//         end: "bottom top",
//         scrub: true,
//         // markers: true,
//       },
//     }
//   );
// }, []);

  useEffect(() => {

    
    gsap.fromTo(
      sectionRef.current,
      { opacity: 0, x: -100 }, // Initial state
      {
        opacity: 1,
        x: 0,
        duration: 3,
        scrollTrigger: {
          trigger: sectionRef.current,
          // start: 'top 80%', // Start the animation when top of the section reaches 80% of the viewport
          toggleActions: "play none none reverse", // Plays animation on scroll
        },
      }
    );
    gsap.fromTo(
      sectionRef2.current,
      { opacity: 0, y: 50 }, // Initial state
      {
        opacity: 1,
        y: 0,
        duration: 3,
        scrollTrigger: {
          trigger: sectionRef2.current,
          // start: 'top 80%', // Start the animation when top of the section reaches 80% of the viewport
          toggleActions: "play none none reverse", // Plays animation on scroll
        },
      }
    );
  }, []);

  return (
    <section id="Experience" data-scroll-section>
      <div id="Experince">
        <div className="Experince-div-wrapper">
          <div className="Experience-div" ref={sectionRef}>
            <div className="Exp-div-small">
              <svg
                width="107"
                height="50"
                viewBox="0 0 107 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.3335 26.0325C22.3515 27.5052 23.5599 28.6844 25.0325 28.6665C26.5052 28.6485 27.6844 27.4401 27.6665 25.9675C27.6485 24.4948 26.4401 23.3156 24.9675 23.3335C23.4948 23.3515 22.3156 24.5599 22.3335 26.0325ZM25.0061 26.5L107.006 25.5L106.994 24.5L24.9939 25.5L25.0061 26.5Z"
                  fill="black"
                />
                <circle cx="25" cy="25" r="24.5" stroke="black" />
              </svg>
              <h1 className="experince-div-h1">my experience</h1>
            </div>
            <h1 className="Exp-div-h1">Experince</h1>
            <svg
              className="spinner-Experince"
              xmlns="http://www.w3.org/2000/svg"
              width="168"
              height="193"
              viewBox="0 0 168 193"
              fill="none"
            >
              <path
                d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
                fill="#D6D1CE"
              />
            </svg>

            {/* <p>Years Of Experince {<MdOutlineArrowRightAlt className="arrowright" />}<strong className='experince-strong'> 1</strong></p> */}
          </div>

          <div
            className="Experince-div-2"
            ref={sectionRef2}
            data-scroll
            data-scroll-speed="5"
          >
            <div className="Experince-div-2-img-div">
              {/* <img src={Weblogo} style={{ width: "1161px" }} /> */}
            </div>
            <div className="Experince-div-2-dis">
              <div
                className="Experince-div-2-dis-div-1"
                style={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  height: "50px",
                }}
              >
                <p className="Experince-div-2-dis-p">
                  Company{<MdOutlineArrowRightAlt className="arrowright" />}{" "}
                </p>
                <p className="Exp-div-2-p">Web Impetus</p>
              </div>
              <div
                className="Experince-div-2-dis-div-2"
                style={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  height: "50px",
                }}
              >
                <p className="Experince-div-2-dis-p">
                  Role {<MdOutlineArrowRightAlt className="arrowright" />}{" "}
                </p>
                <p className="Exp-div-2-p">Frontend Developer</p>
              </div>
              <p className="Experince-div-2-dis-p-duration">
                Duration {<MdOutlineArrowRightAlt className="arrowright" />}{" "}
                April 2023{<MdOutlineArrowRightAlt className="arrowright" />}May
                2025
              </p>
              <div
                className="Experince-div-Dis-and-p"
                style={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <p className="Experince-div-2-dis-p-disription">
                  Discription{" "}
                  {<MdOutlineArrowRightAlt className="arrowright" />}
                </p>
                <p
                  className="Exp-exprince-P"
                  // style={{
                  //   // fontSize: '60px',
                  //   // textAlign: 'center',
                  //   background: "white", // Gradient color
                  //   WebkitBackgroundClip: 'text',     // Clips the gradient to the text
                  //   WebkitTextFillColor: 'transparent', // Makes the text transparent to show the gradient
                  //   opacity: 0,                       // Start with hidden opacity
                  // }}
                >
                  Developed and maintained responsive webapplications using
                  React.js, HTML, and CSS. Implemented state management using
                  Redux ttensure efficient data flow across the
                  application.Collaborated with designers to create intuitive
                  anduser-friendly UI components.Optimized web applications for
                  maximum speed andscalability. Utilized version control systems
                  like Git for efficientcollaboration and project management.
                  Worked in an Agile/Scrum environment to deliverprojects on
                  time and meet client requirements.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <hr /> */}
      </div>
    </section>
  );
}

export default Experience;

// ✺
